import { RouteConfig } from 'react-router-config';
import { getAdminMenus } from '../../config/menu';
import './style.scss';
import { Header } from '../component/header';

import { useEffect, useState } from 'react';
import { getObject } from '../../lib/local-storage/interface-base';
import { AdminLeftSide } from './components/left-side';
import classNames from 'classnames';
import { getConfig } from '../../config';
import { useSelector } from 'react-redux';
import { IRootState } from '../../store/reducers';
import { useHistory, useLocation } from 'react-router';

import { SupportRightSide } from './right-side';

export interface IProps {
  readonly route?: RouteConfig;
}
export const AdminCenter = (props: IProps) => {
  const location = useLocation();
  const history = useHistory();
  const userInfo = useSelector((state: IRootState) => state.common.userInfo);

  const [collapsed, setCollapsed] = useState<boolean>(
    getObject<boolean>('menuCollapsed') || false
  );

  const handleCollapsedChange = (newCollapsed: boolean) => {
    setCollapsed(newCollapsed);
  };

  const { devPerson } = getConfig();
  const isDevPerson = devPerson.includes(userInfo?.UserID || '');
  const showDevMenu = getAdminMenus(isDevPerson);

  useEffect(() => {
    if (
      !isDevPerson &&
      ['/admin/permission', '/admin/support-permission'].includes(
        location.pathname
      )
    ) {
      history.push('/404');
    }
  }, [location]);

  return (
    <div className="admin-page-content">
      <div className="account-wrapper-content admin-layout-box">
        <Header isSmallLogo={true} />
        <div className="content-main-box">
          <AdminLeftSide
            menus={showDevMenu}
            showHeader={false}
            showFooter={true}
            onCollapsedChange={handleCollapsedChange}
          />
          <div
            className={classNames('content-box admin-content', {
              'content-admin-collapsed': !collapsed,
            })}
          >
            <SupportRightSide {...props} />
          </div>
        </div>
      </div>
    </div>
  );
};
